import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/icons/close.svg'
import _imports_1 from '@/assets/icons/close-primary.svg'
import _imports_2 from '@/assets/icons/error.svg'


const _hoisted_1 = {
  key: 0,
  class: "flex justify-center items-center fixed inset-y-0 right-0 overflow-x-hidden overflow-y-hidden z-50 w-full"
}
const _hoisted_2 = { class: "flex relative w-3/5 h-auto" }
const _hoisted_3 = { class: "flex flex-col bg-white w-full h-auto rounded-2xl shadow p-8" }
const _hoisted_4 = { class: "flex flex-row justify-between" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-semibold" }, "Invite account member", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row mt-4" }, [
  /*#__PURE__*/_createElementVNode("span", null, " Add members to your team and do more with Axelerate together! Teams make it easier to divide responsibilities and keep everything under one roof. ")
], -1)
const _hoisted_9 = { class: "flex flex-col mt-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "h-px bg-gray-200 w-full my-2" }, null, -1)
const _hoisted_11 = { class: "flex flex-row items-center mt-4" }
const _hoisted_12 = { class: "flex flex-row flex-wrap w-3/4 bg-background rounded px-4 pb-4 pt-2 focus:outline-none focus:ring-2 focus:ring-black focus:bg-white" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  key: 0,
  class: "flex flex-row text-red-500 justify-center bg-red-200 rounded p-2 w-1/2 mt-4"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "mr-2 w-6 h-6"
}, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, "Please enter a valid email address", -1)
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = {
  key: 1,
  class: "flex flex-row text-red-500 justify-center bg-red-200 rounded p-2 w-2/3 mt-4"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "mr-2 w-6 h-6"
}, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", null, "Something went wrong, please try again", -1)
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = { class: "flex flex-row items-center my-4" }
const _hoisted_28 = { class: "bg-background rounded p-4" }
const _hoisted_29 = ["value"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "ml-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " For team members who help with onboarding, adjusting payments and performing payments. ")
], -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "h-px bg-gray-200 w-full my-2" }, null, -1)
const _hoisted_32 = {
  key: 1,
  class: "bg-black opacity-50 fixed inset-y-0 right-0 z-40 w-full"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.openModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeModalStatus && _ctx.changeModalStatus(...args)))
                }, _hoisted_7)
              ]),
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invitedEmails, (invite, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: i,
                        class: "flex flex-row bg-primary-light text-primary rounded p-2 truncate my-2 mr-2"
                      }, [
                        _createElementVNode("span", null, _toDisplayString(invite), 1),
                        _createElementVNode("button", {
                          onClick: ($event: any) => (_ctx.removeInvite(i))
                        }, _hoisted_15, 8, _hoisted_13)
                      ]))
                    }), 128)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newEmail) = $event)),
                      onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addToInvites(_ctx.newEmail))),
                      onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.addToInvites(_ctx.newEmail)), ["enter"])),
                      onKeydown: _cache[4] || (_cache[4] = ($event: any) => (_ctx.emailError = false)),
                      type: "text",
                      placeholder: "Email",
                      class: "bg-background focus:outline-none w-full mt-2"
                    }, null, 544), [
                      [_vModelText, _ctx.newEmail]
                    ])
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.sendInvitation && _ctx.sendInvitation(...args))),
                    disabled: _ctx.invitedEmails.length < 1 || _ctx.loading,
                    class: "bg-primary text-white rounded-full p-4 ml-4 disabled:opacity-50 disabled:cursor-not-allowed"
                  }, [
                    (_ctx.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, "Loading..."))
                      : (_openBlock(), _createElementBlock("span", _hoisted_18, "Send invite"))
                  ], 8, _hoisted_16)
                ]),
                (_ctx.emailError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_22))
                  : _createCommentVNode("", true),
                (_ctx.apiError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_26))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("select", _hoisted_28, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, i) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: i,
                        class: "capitalize",
                        value: option
                      }, _toDisplayString(option), 9, _hoisted_29))
                    }), 128))
                  ]),
                  _hoisted_30
                ]),
                _hoisted_31
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.openModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_32))
      : _createCommentVNode("", true)
  ], 64))
}